import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const locationStateWhitelist = [
  {
    route: '/profile',
    stateKeys: 'all',
  },
  {
    route: '/auth/otp',
    stateKeys: ['msisdn'],
  },
  {
    route: '/auth/set-password',
    stateKeys: ['msisdn'],
  },
];

const useLocationState = () => {
  const { pathname, state, hash, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // remove adition keys
    Object.keys(localStorage)?.forEach((item) => {
      if (item.includes('routeState') && item !== `routeState${pathname}`) {
        localStorage.removeItem(item);
      }
    });

    let routeState = {};
    if (!state || state === null) {
      // if state is empty get it from localstorage
      routeState = localStorage.getItem(`routeState${pathname}`);
      if (routeState) {
        routeState = JSON.parse(routeState);
      }
    } else {
      // if have state reset or refresh with white list keys
      locationStateWhitelist?.forEach((item) => {
        if (pathname.includes(item.route)) {
          if (item.stateKeys === 'all') {
            routeState = state;
          } else {
            Object.keys(state)?.forEach((stateKey) => {
              if (item.stateKeys.includes(stateKey)) {
                routeState = {
                  ...routeState,
                  [stateKey]: state[stateKey],
                };
              }
            });
          }
        }
      });

      // set white list keys localstorage
      localStorage.setItem(`routeState${pathname}`, JSON.stringify(routeState));
    }

    navigate({ hash, search }, { replace: true, state: routeState });

    return () => navigate({ hash, search }, { replace: true, state: routeState });
  }, [pathname]);
};

export default useLocationState;
